import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import { Button, Checkbox, CheckboxGroup, Collapsible, Dropdown, Form, Input, Modal, Radio, RadioGroup, Toast, Upload } from '@douyinfe/semi-ui';
import useRequest from '@/utils/useRequest';
import { Router, useRouter } from 'next/router';
import { IndexContext } from "@/stores";
import classNames from 'classnames';
import { debounce, toArray } from 'lodash';
import Head from 'next/head';
import { PRODDOMAIN } from '@/utils';

interface IProps {
}

const Register: NextPage<IProps> = ({ }) => {
  const router = useRouter() as any
  const [country, setCountry] = useState([])
  const [region, setRegion] = useState([])
  const [companyTypes, setCompanyTypes] = useState([])
  const [cate, setCate] = useState([])
  const [selectCate, setSelectCate] = useState<number[]>([])
  const [selectSubCate, setSelectSubCate] = useState<number[]>([])
  const [selectThreeCate, setSelectThreeCate] = useState<number[]>([])
  const [city, setCity] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const formRef = useRef<any>()
  const checkbox = useRef<any>()
  const { setIsHeadFoot, setLang } = useContext(IndexContext);
  const request = useRequest()
  const vcode_key = useRef<number>(new Date().getTime())
  const [reload, setReload] = useState<any>(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key}`)
  const [countdown, setCountdown] = useState(0);
  const [idTypes, setIdTypes] = useState<any>([])
  const [selectType, setSelectType] = useState()
  const [memberTypes, setMemberTypes] = useState<any>([])
  const [forum, setForum] = useState<any>([])
  const [purpose, setPurpose] = useState<any>([])
  const [business, setBusiness] = useState<any>([])
  const [ways, setWays] = useState<any>([])
  const timerRef = useRef<any>();

  const btnClick = useCallback(() => {
    if (!checkbox.current) {
      Toast.error({
        content: '请先同意《隐私条款》',
      })
      return
    }
    console.log(selectCate, selectSubCate, formRef.current.getFormState().values);

    formRef.current.validate().then(async () => {
      const { purpose, business_area, interested_forum, truename, is_forum, way_understand, gender, ...params } = formRef.current.getFormState().values
      // if (is_forum == 1 && !interested_forum?.length) {
      //   Toast.error({
      //     content: '请选择感兴趣的论坛',
      //   })
      //   return
      // }
      // if (![...selectCate, ...selectSubCate].length) {
      //   Toast.error({
      //     content: '请至少选择一个主要业务领域',
      //   })
      //   return
      // }

      const { data } = await request.post('/visitor/do_reg', {
        ...params,
        gender,
        is_forum,
        truename,
        // interest_area: [...selectCate, ...selectSubCate, ...selectThreeCate].join(','),
        vcode_key: vcode_key.current,
        // purpose: purpose.join(','),
        // business_area: business_area.join(','),
        // interested_forum: !!interested_forum ? interested_forum.join(',') : '',
        // way_understand: way_understand.join(','),
        source_ex_id: !!router.query?.source_ex_id ? router.query?.source_ex_id : ''
      })

      if (data?.code == 1) {
        Toast.success({
          content: "提交成功",
        })
        document.cookie = `v_token=${data?.data?.jwt}; Expires=${new Date(data?.data?.payload?.expire * 1000).toUTCString()}; Path=/; Secure; SameSite=Lax`;
        router.push(`/register/success?name=${truename}&gender=${gender}`)
      } else {
        Toast.error({
          content: data.msg,
        })
      }

    }).catch((err: any) => {
      console.log(err);

      Toast.error({
        content: '请填写完整信息',
        duration: 3,
      })
    })

  }, [selectCate, selectSubCate, selectThreeCate, router.query])

  const sendCaptcha = useCallback(async () => {
    const { mobile, vcode, email, user_type } = formRef.current.getFormState().values

    if (user_type == '1' && !mobile) {
      Toast.error('请输入手机号')
      return
    }
    if (user_type == '2' && !email) {
      Toast.error('请输入邮箱')
      return
    }
    if (!vcode) {
      Toast.error('请输入图形验证码')
      return
    }
    const params = user_type == '1' ?
      {
        mobile,
        vcode,
        vcode_key: vcode_key.current
      }
      : {
        email,
        vcode,
        vcode_key: vcode_key.current
      }
    try {
      const { data } = await request.post(user_type == '1' ? '/visitor/ajax/send_sms_code' : '/visitor/ajax/send_email_code', params)
      if (data?.code != 1) {
        vcode_key.current = new Date().getTime()
        setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
        Toast.error(data?.msg)
        return
      }
      // 开始倒计时
      setCountdown(60);
    } catch (error) {
      console.error('验证码发送失败:', error);
      setCountdown(0); // 出错时重置状态
    }
  }, []);

  const transOption = useCallback((arr: any = []) => {
    if (!arr.length) return []
    return arr?.map((item: any) => {
      return {
        ...item,
        childlist: transOption(item.childlist),
        key: item.id,
        value: item.id,
        label: item.name_cn || item.title_cn || item.name
      }
    })
  }, [])


  const findDifference = (arr1: number[], arr2: number[]): number => {
    // 使用 Set 来方便地进行数组差异的计算
    const set2 = new Set(arr2) as any;
    for (const num of arr1) {
      if (!set2.has(num)) {
        return num; // 找到第一个不在arr2中的元素并返回
      }
    }
    return 0
  }


  const clearNodes = useCallback((id: number) => {
    const findNodeRecursive = (nodes: any[], targetId: number): any => {
      return nodes.reduce((found, node) => {
        if (found) return found; // 如果已经找到，直接返回
        if (node.id === targetId) return node; // 当前节点匹配
        return findNodeRecursive(node.childlist || [], targetId); // 递归查找子节点
      }, null);
    };

    const getAllDescendantIds = (node: any): number[] => {
      if (!node?.childlist) return [];
      return node.childlist.flatMap((child: any) => [
        child.id,
        ...getAllDescendantIds(child)
      ]);
    };
    console.log('clear');


    const targetNode = findNodeRecursive(cate, id);
    console.log(targetNode);

    if (!targetNode) return;

    const idsToClear = new Set([id, ...getAllDescendantIds(targetNode)]);
    console.log(idsToClear);


    setSelectSubCate(prev => prev.filter(id => !idsToClear.has(id)));
    setSelectThreeCate(prev => prev.filter(id => !idsToClear.has(id)));
  }, [cate]);


  const getCity = useCallback(async (pid: string) => {
    const { data } = await request.get(`/api/region/list`, {
      params: {
        pid
      }
    })
    const arr = transOption(toArray(data?.data?.list))

    setCity(arr)
  }, [])

  const getFiled = useCallback((filed: string) => {
    return formRef.current.getValue(filed)
  }, [formRef.current])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/api/region/data`)
    const { data: info } = await request.get(`/api/setting/info`)
    const { data: types } = await request.get(`/visitor/ajax/idcard_types_list`)
    const { data: memberTypes } = await request.get(`/visitor/ajax/member_types_list`)
    const { data: forum } = await request.get(`/visitor/ajax/forum_list`)
    const { data: purpose } = await request.get(`/visitor/ajax/purpose_types_list`)
    const { data: business } = await request.get(`/visitor/ajax/business_list`)
    const { data: ways } = await request.get(`/visitor/ajax/know_way_list`)

    setCate(transOption(info?.data?.category))
    setCompanyTypes(transOption(Array.from({
      ...info?.data?.company_types,
      length: Object.keys(info?.data?.company_types).length + 1
    }).slice(1) as any))
    setIdTypes(transOption(types?.data))
    setMemberTypes(transOption(memberTypes?.data))
    setForum(transOption(forum?.data))
    setCountry(transOption(data?.data?.country))
    setRegion(transOption(data?.data?.province))
    setPurpose(transOption(purpose?.data))
    setBusiness(transOption(business?.data))
    setWays(transOption(ways?.data))
    formRef.current?.setValue('country_id', 256)
  }, [])

  useEffect(() => {
    if (countdown > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timerRef.current);
  }, [countdown]);

  useEffect(() => {
    setIsHeadFoot(false)
    getData()
    return () => {
      setIsHeadFoot(true)
    }
  }, [])


  return (
    <div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <p><span style={{ color: '#f79700' }}>为健康发声</span><br className='minHidden' />为未来行动</p>
            <div className={styles.info}>
              <h1>亚洲有机产业展览会</h1>
              <p>
                <span className={styles.time}>2025.09.03-05</span>
                <span className={styles.site}>上海新国际博览中心</span>
              </p>
            </div>
            <div className={styles.btns}>
              <a href="https://www.organic-festa.com/">
                <div className={styles.backBtn} style={{ backgroundColor: 'transparent' }}>返回首页</div>
              </a>
              <a href="/login">
                <div className={styles.backBtn}>已是观众，返回登录</div>
              </a>
            </div>
          </div>
          <div className={styles.form}>
            <div className={styles.title}>
              <h2>观众登记<span>标记*为必填</span></h2>
              <Dropdown
                style={{ width: '148px' }}
                render={
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
                    <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
                  </Dropdown.Menu>
                }
              >
                <div className={styles.langBtn}>
                  语言：
                </div>
              </Dropdown>
            </div>
            <img className='minHidden' src="/image/register-step.png" alt="" />
            <Form
              getFormApi={(formApi: any) => formRef.current = formApi}
              labelPosition="left"
              labelWidth="145px"
              labelAlign="right"
              style={{ marginTop: '40px' }}
            >
              {
                (({ }) => (
                  <div>
                    <h3>账号信息</h3>
                    <Form.Slot label={(
                      <></>
                    )}>
                      <div className={styles.types}>
                        <Form.RadioGroup
                          options={[{ label: '中国大陆', value: '1' }, { label: '非中国大陆', value: '2' }]}
                          field="user_type"
                          noLabel
                          direction="horizontal"
                          initValue={'1'}
                          onChange={(e) => {
                            console.log(e.target.value);
                            e.target.value == 1 ? formRef.current.setValue('country_id', 256)
                              : formRef.current.reset(['country_id'])
                          }}
                        />
                      </div>
                    </Form.Slot>
                    <div className={styles.twoCol}>
                      {getFiled('user_type') == '1' ? <Form.Slot className='custom' label={(
                        <span className={styles.required}>手机</span>
                      )}>
                        <div className={styles.phone}>
                          <Form.Input
                            field="mobile_code"
                            noLabel
                            trigger='blur'
                            initValue={'86'}
                            disabled
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                          <Form.Input
                            field="mobile"
                            placeholder='手机号码'
                            noLabel
                            trigger='blur'
                            rules={[
                              { required: true, message: '必填项' },
                              {
                                pattern: /^1[3-9]\d{9}$/,
                                message: '请输入正确的手机号码'
                              }
                            ]}
                          />
                        </div>
                      </Form.Slot>
                        : <Form.Input
                          field="email"
                          label={(<span className={styles.required}>邮箱</span>)}
                          placeholder="请输入邮箱"
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                            {
                              validator: (rule, value) => {
                                const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                return emailRegex.test(value);
                              }, message: '请输入有效邮箱'
                            }
                          ]}
                        />}
                      <Form.Slot className='custom' label={(
                        <span className={styles.required}>图形验证码</span>
                      )}>
                        <div className={styles.imgCode}>
                          <Form.Input
                            field="vcode"
                            noLabel
                            placeholder="请输入图形验证码"
                            trigger='blur'
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                          {reload && <img src={reload} onClick={() => {
                            vcode_key.current = new Date().getTime()
                            setReload(`${PRODDOMAIN}/visitor/ajax/get_verify?key=${vcode_key.current}`)
                          }} alt="" />}
                        </div>
                      </Form.Slot>
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Slot className='custom' label={(
                        <span className={styles.required}>{getFiled('user_type') == '1' ? '手机验证码' : '邮箱验证码'}</span>
                      )}>
                        <div className={styles.vCode}>
                          <Form.Input
                            field="vcode"
                            noLabel
                            placeholder={getFiled('user_type') == '1' ? '请输入手机验证码' : '请输入邮箱验证码'}
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                          <Button
                            onClick={debounce(() => sendCaptcha(), 500)}
                            disabled={countdown > 0}
                          >{countdown > 0 ? `${countdown}秒后可重发` : '获取验证码'}</Button>
                        </div>
                      </Form.Slot>
                      <Form.Input
                        field="password"
                        label={(<span className={styles.required}>设置登录密码</span>)}
                        placeholder="请输入登录密码"
                        type='password'
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                          {
                            pattern: /^.{6,16}$/,
                            message: '密码需6-16位'
                          }
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Input
                        field="verify_password"
                        label={(<span className={styles.required}>确认登录密码</span>)}
                        placeholder="请输入密码"
                        type='password'
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                          {
                            pattern: /^.{6,16}$/,
                            message: '密码需6-16位'
                          }
                        ]}
                      />
                    </div>
                    <h3 className={styles.formTitle}>个人信息</h3>
                    <div className={styles.twoCol}>
                      <Form.Input
                        field="truename"
                        label={(<span className={styles.required}>姓名</span>)}
                        placeholder="请输入姓名"
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />
                      <Form.RadioGroup
                        options={[{ label: '先生', value: '1' }, { label: '女士', value: '2' }]}
                        style={{ gap: '20px 40px' }}
                        field="gender"
                        label={(<span className={styles.required}>称谓</span>)}
                        direction="horizontal"
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Select
                        field="certificates_type"
                        label={(<span className={styles.required}>证件类型</span>)}
                        placeholder='请选择类型'
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                        optionList={idTypes}
                        onSelect={(value: any, option: any) => { }}
                      />
                      <Form.Input
                        field="certificates"
                        label={(<span className={styles.required}>证件号码</span>)}
                        placeholder="请输入证件号码"
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      {getFiled('user_type') == '1' ? <Form.Input
                        field="email"
                        label={(<span className={styles.required}>邮箱</span>)}
                        placeholder="请输入邮箱"
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                          {
                            validator: (rule, value) => {
                              const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              return emailRegex.test(value);
                            }, message: '请输入有效邮箱'
                          }
                        ]}
                      />
                        : <Form.Slot className='custom' label={(
                          <span className={styles.required}>手机</span>
                        )}>
                          <div className={styles.phone}>
                            <Form.Input
                              field="mobile_code"
                              noLabel
                              trigger='blur'
                              rules={[
                                { required: true, message: '必填项' },
                              ]}
                            />
                            <Form.Input
                              field="mobile"
                              placeholder='手机号码'
                              noLabel
                              trigger='blur'
                              rules={[
                                { required: true, message: '必填项' },
                                {
                                  pattern: /^1[3-9]\d{9}$/,
                                  message: '请输入正确的手机号码'
                                }
                              ]}
                            />
                          </div>
                        </Form.Slot>}
                      <Form.Input
                        field="company_cn"
                        label={(<span className={styles.required}>公司名称</span>)}
                        placeholder="请输入公司名称"
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      {/* <Form.Input
                        field="position"
                        label={(<span>职位</span>)}
                        placeholder="请输入职位"
                      /> */}
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Select
                        filter
                        field="country_id"
                        label={(<span className={styles.required}>国家/地区</span>)}
                        placeholder='请选择'
                        onSelect={(value: any, option: any) => {
                          formRef.current.setValue('mobile_code', option.code)
                        }}
                        optionList={country}
                        disabled={getFiled('user_type') == '1'}
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />
                      {getFiled('country_id') == 256 && <Form.Slot className='custom' label={(
                        <span className={styles.required}>省份/城市</span>
                      )}>
                        <div className={styles.address}>
                          <Form.Select
                            filter
                            field="province_id"
                            noLabel
                            placeholder='省份'
                            optionList={region}
                            onSelect={(value: any, option: any) => {
                              getCity(value)
                              formRef.current.reset(['city_id'])
                            }}
                            trigger='blur'
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                          <Form.Select
                            filter
                            field="city_id"
                            noLabel
                            placeholder='市区'
                            optionList={city}
                            onSelect={(value: any, option: any) => {
                              formRef.current.setValue('phone_zone', option.area_code)
                            }}
                            trigger='blur'
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                        </div>
                      </Form.Slot>}
                    </div>
                    {/* <div className={styles.twoCol}>
                      <Form.Input
                        field="address_cn"
                        label={(<span>详细地址</span>)}
                        placeholder="请输入详细地址"
                      />
                      <Form.Select
                        field="company_type"
                        label={(<span className={styles.required}>所属单位性质</span>)}
                        placeholder='请选择'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                        optionList={companyTypes}
                        onSelect={(value: any, option: any) => { }}
                      />
                    </div>
                    <div className={styles.twoCol}>
                      <Form.Input
                        field="website"
                        label={(<span>网址</span>)}
                        placeholder="请输入网址"
                      />
                    </div> */}
                  </div>
                ))
              }
            </Form>

            <div className={styles.footer}>
              <div className={styles.allow}>
                <Checkbox className='is-check' onChange={(e) => checkbox.current = e.target.checked}>
                  <p style={{ color: 'white' }}>我已同意</p>
                </Checkbox>
                <span onClick={() => setIsOpen(!isOpen)}>《隐私条款》</span>
                <p>并确认已阅读及明白上述内容。</p>
              </div>
              <Collapsible isOpen={isOpen}>
                <p className={styles.allowText}>
                  本人在此授权杜塞尔多夫展览（上海）有限公司
                  （"MDS"）收集、处理和使用本人提供的信息，用
                  于内部客户管理。本人知晓：我所提供的信息将会
                  被传输至MDS的海外集团公司（如：德国杜塞尔多夫
                  展览集团）以及外部服务提供商做进一步处理/使用。
                  此外，本人同意MDS及其集团公司基于我向MDS提供的
                  信息，通过邮递信件、电子邮件、短信/彩信以及电
                  话等方式向我发送商业讯息（包括但不限于通知、问
                  卷调查和展览提醒）。</p>
              </Collapsible>
              <div className={styles.btns}>
                <div className={styles.subBtn} onClick={debounce(() => btnClick(), 500)}>提交</div>
              </div>

            </div>
          </div>
        </div>
        <style global jsx>
          {
            `

            `
          }
        </style>
        <p>Copyright © 2025 杜塞尔多夫展览有限（上海）公司  版权所有 <a href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备13014242号-28</a></p>
      </div >
    </div >
  );
};

export default Register;
